import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import {
  Button, Input, Space, Form, Select, Spin, message, Typography, Avatar, Upload
} from 'antd';
import {
  UploadOutlined, LoadingOutlined, UserOutlined,
  EyeInvisibleOutlined, EyeTwoTone
} from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import useAxios from './CustomHooks/useAxios';
import loginSlice from './redux/loginSlice';
const { Option } = Select;
const { Title, Paragraph, Text, Link } = Typography;

export default function Profile({ setVisible }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.loginReducer.user);
  const avatarVersion = useSelector((state) => state.loginReducer.avatarVersion);
  const [messageEmailTxt, setMessageEmailTxt] = useState('')
  const [messagePasswordTxt, setMessagePasswordTxt] = useState('')

  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  // console.log('[Profile]:user=', user?.agents[0]);
  const { axiosi } = useAxios();
  // ===========================================================
  // Tạo URL avatar của user hiện tại
  // ===========================================================
  const agent = user?.agents?.[0];
  const isSSO = Boolean(agent?.sso_provider && Number(agent.sso_provider) !== 0);
  const avatarUrl = agent?.company_id && agent?.endpoint_id
    ? `${process.env.REACT_APP_API_URL}/records/${agent.company_id}/images/${agent.endpoint_id}.jpg?v=${avatarVersion}`
    : null;



  // useEffect(()=>{
  //   message.info("Youre password is expired! Please change your password !")
  // },[])

  function isStrongPwd1(password) {
    var regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{10,}/;
    var validPassword = regExp.test(password);
    return validPassword;
  }
  const handleLogoutFlow = async () => {
    try {
      // Gọi API logout để server xóa Cookie
      await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/logout`,
        { user },
        { withCredentials: true }
      );
    } catch (e) {
      console.error("Logout error:", e);
    }
    // Xóa sạch LocalStorage
    // localStorage.clear();
    localStorage.removeItem("loginStatus");

    // Reload trang để văng ra màn hình Login
    window.location.reload();
  };
  const onFinishAdd = async (values) => {

    try {
      if (values.password) {
        if (!isStrongPwd1(values.password)) {
          message.info("The Agent password must have atleast 10 chars with one uppercase letter, one lower case letter, one digit and one of !@#$%*()");
          return;
        }
      }
      const kq = await axiosi.put(`agents/${user?.agents[0].id}/updateprofile`, {
        ...values, company_id: user?.agents[0].company_id
      });
      console.log("[onFinishAdd]:kq=", kq);
      console.log("[onFinishAdd]:kq=", JSON.stringify(kq));
      setVisible(false);
      message.info("Successful updated ! Please logout and login again to apply the new change !")
      setTimeout(async () => {

        await handleLogoutFlow();
      }, 2000);

      // setSelectedItem(null);
      // setRefreshSearch(pre=>!pre);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data.message) {
          message.error(`Error: ${error.response.data.message}`);
        } else {
          message.error(`Error: ${error.response.data.code}`);
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    }
  }
  // ===========================================================
  // Xử lý upload avatar
  // ===========================================================
  const handleAvatarUpload = async (file) => {
    // Kiểm tra định dạng file
    const isJpg = file.type === 'image/jpeg' || file.type === 'image/jpg';
    if (!isJpg) {
      message.error('Chỉ được upload file .jpg hoặc .jpeg!');
      return false; // Trả về false để ngăn Upload component tự upload
    }

    // Kiểm tra kích thước file (tối đa 5MB)
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error('Kích thước file phải nhỏ hơn 5MB!');
      return false;
    }

    // Bắt đầu upload
    setUploadingAvatar(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      // Gửi thêm company_id và endpoint_id để backend biết lưu vào đâu
      formData.append('company_id', agent.company_id);
      formData.append('endpoint_id', agent.endpoint_id);

      const kq = await axiosi.post(`agents/${agent.id}/avatar`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      console.log("[handleAvatarUpload]: kq=", kq.data);
      message.success('Upload avatar thành công!');

      // Cập nhật avatarVersion trong Redux để tất cả component hiển thị ảnh mới
      const newVersion = kq.data.avatarVersion || Date.now();
      dispatch(loginSlice.actions.setAvatarVersion({ avatarVersion: newVersion }));

    } catch (err) {
      console.error("[handleAvatarUpload]: err=", err);
      message.error('Upload avatar thất bại! ' + (err.response?.data?.message || err.message));
    } finally {
      setUploadingAvatar(false);
    }

    return false; // Luôn trả về false để ngăn antd Upload tự upload
  };
  const onFinishFailedAdd = (error) => {
    console.log("[onFinishFailedAdd]:error=", error);
  }


  useEffect(() => {
    if (user?.agents && user.agents[0] && !user.agents[0].email) {
      setMessageEmailTxt('Your email is empty! Please  update your email !')
    } else {
      setMessageEmailTxt('');
    }
  }, [user])

  useEffect(() => {


    if (user?.agents && user.agents[0] && user.agents[0].pw_dateleft == 0) {
      setMessagePasswordTxt('Your password is expired! Please change your password !')
    } else
      if (user?.agents && user.agents[0] && user.agents[0].must_change_password == 1) {
        setMessagePasswordTxt('Your password must change! Please change your password !')
      } else {
        setMessagePasswordTxt('');
      }
  }, [user])

  return (
    <>
      {/* ===== PHẦN AVATAR ===== */}
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <Avatar
          size={100}
          icon={<UserOutlined />}
          src={avatarUrl}
          onError={() => false} // fallback về icon nếu ảnh chưa tồn tại
          style={{ border: '2px solid #1890ff', marginBottom: 12 }}
        />
        <div>
          <ImgCrop
            rotation={true}
            grid={true}
            aspect={1}
            modalTitle="Chỉnh sửa ảnh đại diện"
            modalOk="Lưu"
            modalCancel="Hủy"
          >
            <Upload
              accept=".jpg,.jpeg"
              showUploadList={false}
              beforeUpload={handleAvatarUpload}
            >
              <Button
                icon={uploadingAvatar ? <LoadingOutlined /> : <UploadOutlined />}
                loading={uploadingAvatar}
                disabled={uploadingAvatar}
              >
                {uploadingAvatar ? 'Đang upload...' : 'Đổi ảnh đại diện'}
              </Button>
            </Upload>
          </ImgCrop>
          <div style={{ marginTop: 4, color: '#888', fontSize: 12 }}>
            Chỉ hỗ trợ file .jpg, kích thước tối đa 5MB
          </div>
        </div>
      </div>
      {/* ===== KẾT THÚC PHẦN AVATAR ===== */}



      <Form
        name="basic"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 14 }}
        initialValues={{ ...user?.agents[0] }}
        onFinish={onFinishAdd}
        onFinishFailed={onFinishFailedAdd}
        autoComplete="off"
      >




        <Form.Item
          label="Agent Name :"
          name="name"
          rules={[{ required: true, message: 'Please input an Agent name!' }]}
        >
          <Input />

        </Form.Item>


        <Form.Item
          label="Agent Username :"
          name="username"
          rules={[{ required: true, message: 'Please input an Agent username!' }]}
        >
          <Input disabled={isSSO} />
        </Form.Item>

        <Text type="danger">{messagePasswordTxt}</Text>
        <Form.Item
          label="Agent Password :"
          name="password"
          rules={[{ required: false, message: 'Please input an Agent password!' }]}
        >
          <Input.Password placeholder="input Agent password"
            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />


        </Form.Item>




        <Text type="danger">{messageEmailTxt}</Text>
        <Form.Item
          label="Agent email :"
          name="email"
        // rules={[{ required: true, message: 'Please input an email!' }]}
        >
          <Input />


        </Form.Item>

        <Form.Item
          label="Agent tel :"
          name="tel"
        // rules={[{ required: true, message: 'Please input an email!' }]}
        >
          <Input />
        </Form.Item>




        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
      <div>

      </div>
    </>
  )
}
